var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivateAccessForUsers = function SvgPrivateAccessForUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 24c2.76 0 4.98-2.24 4.98-5s-2.22-5-4.98-5-5 2.24-5 5 2.24 5 5 5m-15-2c3.32 0 5.98-2.68 5.98-6s-2.66-6-5.98-6-6 2.68-6 6 2.68 6 6 6m15 6c-3.66 0-11 1.84-11 5.5V38h22v-4.5c0-3.66-7.34-5.5-11-5.5m-15-2c-4.66 0-14 2.34-14 7v5h14v-4.5c0-1.7.66-4.68 4.74-6.94C21 26.2 19.32 26 18 26"
  })));
};
export default SvgPrivateAccessForUsers;